import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivitiesComponent } from './activities/activities.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsReactWrapperComponent } from './notifications/notifications-react-wrapper.component';
import { RoomsComponent } from './rooms/rooms.component';
import { MobileUseComponent } from './mobile-use/mobile-use.component';
import { NewslettersComponent } from './newsletters/newsletters.component';
import { ViewNewsletterComponent } from './newsletters/view-newsletter/view-newsletter.component';
import { EditArticleCanDeactivateGuard } from '../core/guards/edit-article.can-deactivate.guard';
import { DiningManagerGuard } from '../core/guards/dining-manager.guard';
import { AddAnnouncementReactWrapperComponent } from '@features/digital-signage/add-slide/add-slide-react-wrapper.component';
import { SlideTableReactWrapperComponent } from '@features/digital-signage/slide-table/slide-table-react-wrapper.component';
import { MenusReactWrapperComponent } from '@features/menus/menus-react-wrapper.component';

const routes: Routes = [
  {
    path: 'activities',
    component: ActivitiesComponent,
    canActivate: [DiningManagerGuard],
  },
  {
    path: 'announcements',
    component: SlideTableReactWrapperComponent,
    canActivate: [DiningManagerGuard],
  },
  {
    path: 'announcements/add',
    component: AddAnnouncementReactWrapperComponent,
    canActivate: [DiningManagerGuard],
  },
  {
    path: 'announcements/edit/:announcementId',
    component: AddAnnouncementReactWrapperComponent,
    canActivate: [DiningManagerGuard],
  },
  {
    path: 'mobile-use',
    component: MobileUseComponent,
    canActivate: [DiningManagerGuard],
  },
  {
    path: 'newsletters',
    component: NewslettersComponent,
    canActivate: [DiningManagerGuard],
  },
  {
    path: 'newsletters/:newsletterId',
    component: ViewNewsletterComponent,
    canActivate: [DiningManagerGuard],
    canDeactivate: [EditArticleCanDeactivateGuard],
  },
  {
    path: 'notifications',
    component: NotificationsReactWrapperComponent,
    canActivate: [DiningManagerGuard],
  },
  {
    path: 'rooms',
    component: RoomsComponent,
    canActivate: [DiningManagerGuard],
  },
  {
    path: 'menus',
    component: MenusReactWrapperComponent,
  },
  {
    path: '',
    redirectTo: 'activities',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [EditArticleCanDeactivateGuard],
})
export class ManageRoutingModule {}
